import React from "react";
import MasterLayout from "../../../masterLayout/MasterLayout";
import Breadcrumb from "../../../components/Breadcrumb";
import ManageEnquiryLayer from "../../../components/crm/ManageEnquiryLayer";

const ManageEnquiry = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title='Manage Enquiry' />

        {/* BlankPageLayer */}
        <ManageEnquiryLayer />
      </MasterLayout>
    </>
  );
};

export default ManageEnquiry;
